import { Link, useNavigate } from "react-router-dom";
import { Sprout } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth, roleHome } from "@/context/AuthContext";

const NAV = [
    { label: "Internships", to: "/internships" },
    { label: "Projects", to: "/projects" },
    { label: "Faculty", to: "/faculty" },
    { label: "Career Paths", to: "/career-paths" },
    { label: "Support", to: "/support" },
];

export function Logo({ dark = false }) {
    return (
        <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
            <span className="grid h-9 w-9 place-items-center rounded-xl bg-primary text-white">
                <Sprout className="h-5 w-5" />
            </span>
            <span className={`font-display text-xl font-bold tracking-tight ${dark ? "text-white" : "text-foreground"}`}>TechBloom</span>
        </Link>
    );
}

export default function Header() {
    const { user } = useAuth();
    const navigate = useNavigate();
    return (
        <header className="glass sticky top-0 z-50" data-testid="site-header">
            <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6">
                <Logo />
                <nav className="hidden items-center gap-8 md:flex">
                    {NAV.map((n) => (
                        <Link key={n.to} to={n.to} data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                            className="text-sm font-medium text-muted-foreground transition-colors duration-200 hover:text-primary">
                            {n.label}
                        </Link>
                    ))}
                </nav>
                <div className="flex items-center gap-3">
                    {user ? (
                        <Button data-testid="header-dashboard-button" className="rounded-full" onClick={() => navigate(roleHome(user.role))}>
                            Dashboard
                        </Button>
                    ) : (
                        <>
                            <Button data-testid="header-login-button" variant="ghost" className="rounded-full" onClick={() => navigate("/login")}>Log in</Button>
                            <Button data-testid="header-get-started-button" className="rounded-full" onClick={() => navigate("/register")}>Get Started</Button>
                        </>
                    )}
                </div>
            </div>
        </header>
    );
}
